/*
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2022-06-24 15:53:24
 * @LastEditTime : 2024-03-06 09:51:49
 * @LastEditors  : yangxr
 * @Description  : 
 * @FilePath     : \icps_fb\src\api\smart\data.js
 */
import request from "@/utils/request";
export const queryPage = "/icps/system/sign/basics/plan/QuerySignOfPage";
//导出开盘资料
export const exportTende = "/icps/system/sign/basics/handOverInformation/exportTender"
/*获取打印记录列表*/
export function signOfPrintLog(data) {
  return request({
    url: "/icps/system/sign/intelligent/signOfPrintLog/queryPage",
    method: "post",
    data,
  });
}
/*打印或导出*/
export function signOfPrintLogSave(data) {
  return request({
    url: "/icps/system/sign/intelligent/signOfPrintLog/save",
    method: "post",
    data,
  });
}
/*配置列表页面获取工程列表*/
export function queryEngineeringList() {
  return request({
    url: "/icps/system/sign/cloudSell/engineeringManagement/queryEngineeringList",
    method: "get",
  });
}
/*生成交工资料*/
export function handOverInformationsaveResord(data) {
  return request({
    url: "/icps/system/sign/basics/handOverInformation/saveResord",
    method: "post",
    data
  });
}
/*批量排除*/
export function batchExclude(data) {
  return request({
    url: "/icps/system/sign/basics/plan/batchExclude",
    method: "post",
    data
  });
}
/*获取导出原物料*/
export function getRawName(data) {
  return request({
    url: "/icps/system/sign/basics/handOverInformation/getRawName",
    method: "post",
    data
  });
}
/*获取厂家材质报告、合格证*/
export function getReportService(data) {
  return request({
    url: "/icps/system/sign/intelligent/report/maintain/queryPage",
    method: "post",
    data
  });
}
/*获取第三方报告 原物料*/
export function getThirdReport(data) {
  return request({
    url: "/icps/system/sign/intelligent/tripleReport/raw/get_triple_report_page",
    method: "post",
    data
  });
}
/*获取第三方报告 混凝土*/
export function getThirdReport2(data) {
  return request({
    url: "icps/system/sign/intelligent/tripleReport/beton/get_triple_report_page",
    method: "post",
    data
  });
}
/*获取销售计划-工程列表*/
export function querySaleEngList(params) {
  return request({
    url: "icps/system/sign/cloudSell/engineeringManagement/querySaleEngList",
    method: "get",
    params
  });
}
/*添加计划-销售计划- 保存*/
export function saveSaleHnadoverPlan(data) {
  return request({
    url: "icps/system/sign/basics/plan/saveSaleHnadoverPlan",
    method: "post",
    data
  });
}
/*获取生产计划-工程列表*/
export function queryProduceEngList(params) {
  return request({
    url: "icps/system/sign/cloudSell/engineeringManagement/queryProduceEngList",
    method: "get",
    params
  });
}
/*添加计划-生产处计划- 保存*/
export function saveProduceHnadoverPlan(data) {
  return request({
    url: "icps/system/sign/basics/plan/saveProduceHnadoverPlan",
    method: "post",
    data
  });
}
